<template>
  <div style="position: absolute;top: 0">
    11121212121
    <img src="@/images/emptyView.png">
  </div>
</template>

<script>
    export default {
        name: "home1"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/page/home/home1.vue